import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {safeOptional} from '../../safe-optional'
import {FormFieldValidationSchema} from './formFieldValidation'

export const FormFieldTextInputSchema = buildEntrySchemaFor('formFieldTextInput', {
  fields: z.lazy(() =>
    z.object({
      htmlName: z.string(),
      label: z.string(),
      placeholder: z.string().optional(),
      validations: safeOptional(z.array(FormFieldValidationSchema)),
    }),
  ),
})

export type FormFieldTextInput = z.infer<typeof FormFieldTextInputSchema>

export const isFormFieldTextInput = (value: unknown): value is FormFieldTextInput => {
  return FormFieldTextInputSchema.safeParse(value).success
}
